import React from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';

const Spinner = ({ message }) => (
    <Dimmer active inverted>
        <Loader size="huge" content={message || "Loading ..."} />
    </Dimmer>
);

export default Spinner;